import styled from 'styled-components';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';

export const TeamCardStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid rgba(157, 157, 157, 0.3);
  background: var(--white);

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    margin: 0 0 10px;
    padding: 0 23px 0 0;
    position: relative;

    .img-box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      /* padding: 10px; */
      border-radius: 10px;
      background: rgb(135 137 147 / 48%);
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .tag {
      display: inline-block;
      vertical-align: top;
      font-size: 12px;
      line-height: 15px;
      font-weight: 600;
      padding: 6px 8px;
      border-radius: 5px;
      text-transform: uppercase;
      background: var(--gray-100);
    }
  }

  .text-box {
    flex-grow: 1;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color);

    .title {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 600;
      margin: 0 0 6px;
      text-transform: capitalize;
      color: var(--text-color);
    }
    p {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;

      &:last-child {
        margin: 0;
      }
    }
  }

  .card-footer {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;

    .name {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      text-transform: uppercase;
      border-radius: 50px;
      background: var(--primary);
    }
  }
`;

export const MenuBtn = styled(MenuButton)`
  position: absolute;
  top: 50%;
  right: -5px;
  transform: translateY(-50%);
  font-size: 20px;
  line-height: 1px;
`;
export const ReponseMenu = styled(Menu)`
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.133), 0 0 2px rgba(0, 0, 0, 0.1);

  ul {
    width: 200px;
    padding: 10px;
    border-radius: 10px;

    .text {
      font-size: 14px;
      line-height: 17px;
    }
  }
  &.szh-menu-container {
    left: 0 !important;
    right: 0 !important;
  }
  .szh-menu {
    left: auto !important;
    right: 0 !important;
    z-index: 10 !important;
  }
`;

export const StyleItem = styled(MenuItem)`
  display: block;
  padding: 4px 8px;
  margin: 0 0 2px;
  border-radius: 3px;

  &.active,
  &:hover {
    background: var(--gray-100);
  }

  &:last-child {
    margin: 0;
  }
`;
